import React, { useCallback } from 'react'
import useReactRouter from 'use-react-router'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import useListAction from 'core/hooks/useListAction'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { routeManager } from 'core/utils/routes'
import { enableHypervisorScheduling, listHypervisors } from '../../actions'

export default function DisableMaintenanceDialog({ rows: hosts, onClose, onDetailsPage = false }) {
  const host = hosts?.[0]
  const { history } = useReactRouter()
  const { reload: reloadHypervisors } = useListAction(listHypervisors)
  const {
    update: enableHypervisor,
    updating: enablingHypervisor,
    error: errorEnablingHypervisor,
    reset: resetEnableHypervisor,
  } = useUpdateAction(enableHypervisorScheduling)

  const handleDisable = useCallback(async () => {
    const body = {
      host: host?.id,
      binary: 'nova-compute',
    }
    const { success } = await enableHypervisor({ id: host.hypervisor.id, body })
    if (success) {
      reloadHypervisors(true, true)
      if (onDetailsPage) {
        history.push(routeManager.routes.openstack.hosts.path())
      } else {
        handleClose(true)
      }
    }
  }, [host])

  const handleClose = (success?: boolean) => {
    resetEnableHypervisor()
    onClose(success)
  }

  return (
    <Modal
      panel="dialog"
      title="Disable Maintenance Mode"
      onClose={() => handleClose()}
      open
      footer={
        <>
          <Button variant="secondary" onClick={() => handleClose()} disabled={enablingHypervisor}>
            Cancel
          </Button>
          <Button onClick={handleDisable} loading={enablingHypervisor}>
            Confirm
          </Button>
        </>
      }
    >
      <>
        <Text variant="body2">
          Disable maintenance mode on host <b>{host?.name}</b>. Scheduling will be enabled and
          details on the current maintenance will be lost.
        </Text>
        {!!errorEnablingHypervisor && (
          <ErrorMessage>{errorEnablingHypervisor?.message}</ErrorMessage>
        )}
      </>
    </Modal>
  )
}
